import { render, staticRenderFns } from "./menumodal.vue?vue&type=template&id=73600900&"
import script from "./menumodal.vue?vue&type=script&lang=js&"
export * from "./menumodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports